<header>
  @if (this.petitions) {
    <div class="filters">
      @for (status of statuses; track status) {
        <button
          [class.neutral]="status != selectedStatus"
          [disabled]="status == selectedStatus"
          (click)="switchStatus(status)">
          {{ status }}
        </button>
      }
    </div>
  }
  @if (user?.staff) {
    <a role="button" class="colored" routerLink="/campaigns/new">
      <mat-icon>add</mat-icon>
      New
    </a>
  }
</header>

@if (draftPetitions?.length) {
  <div class="crumb">
    <span data-icon="petition" class="icon-before">Draft Petitions</span>
  </div>
  <div class="petition-list">
    @for (petition of draftPetitions; track petition) {
      <tyt-petition-card
        [petition]="petition"
        [image]="true"
        [info]="user.staff"
        (deletePetitionEvent)="onPetitionDelete($event)">
      </tyt-petition-card>
    }
  </div>
}

@if (publishedPetitions?.length) {
  <div class="crumb">
    <span data-icon="petition" class="icon-before">Published Petitions</span>
  </div>
  <div class="petition-list">
    @for (petition of publishedPetitions; track petition) {
      <tyt-petition-card
        [petition]="petition"
        [image]="true"
        [info]="user?.staff"
        (deletePetitionEvent)="onPetitionDelete($event)">
      </tyt-petition-card>
    }
  </div>
}

<tyt-pager [total]="petitions?.total" [page]="page" [size]="20" (changePage)="goToPage($event)"></tyt-pager>
